module.exports = __webpack_public_path__ + "static/media/rss.95e0f190.png";